import { EffectHandler } from "../types/editor"

const StressHanlder: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        editor.addEffectHtml({
            range: selection.range,
            effectType: 'stress',
            effectValue: value,
            effectRender: () => {
            }
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default StressHanlder